<template>
  <div class='timer-scramble'>
    <h2 style='display: inline-block' :class='{completed: $store.state.time !== 0}'> {{ this.$store.state.scramble }} </h2>
      <v-tooltip bottom>
        <template v-slot:activator='{on}'><v-btn v-on='on' text @click='generateScramble'> next </v-btn></template>
        <!-- TODO: disable generateScramble button when owner hasn't yet solved the cube. Also disable if you're not the owner (but leave it visible) -->
        <span>Ctrl+Right</span>
      </v-tooltip>
  </div>
</template>

<script>
import ScramblesService from '@/services/ScramblesService'
import isEqual from 'lodash/isEqual'
export default {
  name: 'timer-scramble',
  data () {
    return {
      keysequence: []
    }
  },
  methods: {
    async generateScramble () {
      var response = await ScramblesService.generateScramble(this.$store.state.sessionId, {
        solverId: this.$store.state.solverId,
        authToken: this.$store.state.authToken,
        globalAuthToken: this.$store.state.globalAuthToken
      })
      var data = response.data
      if (!data.success) {
        alert('Error: ' + data.error)
      }
    },
    nextKeyDown (event) {
      if (this.keysequence[this.keysequence.length - 1] !== event.key) {
        this.keysequence.push(event.key)
      } else {
        return
      }
      if (isEqual(this.keysequence, ['Control', 'ArrowRight'])) {
        this.generateScramble()
      }
    },
    resetKeySequence () {
      this.keysequence = []
    }
  },
  mounted () {
    window.addEventListener('keydown', this.nextKeyDown)
    window.addEventListener('keyup', this.resetKeySequence)
  },
  destroyed () {
    window.removeEventListener('keydown', this.nextKeyDown)
    window.addEventListener('keyup', this.resetKeySequence)
  }
}
</script>

<style scoped>
.completed {
  color: rgba(0, 0, 0, 0.4)
}
</style>
